import React, { useEffect, useState } from "react";

import { AppHeader } from "../../components/header/header";
import { AppFooter } from "../../components/footer/footer";
import { BodySpacer } from "../../components/utilities/body-spacer";
import { PageCaptionImage } from "../../components/page-components/page-caption-box";
import { Blog1  } from "../../components/blogs/jet-lag";
import { Blog2 } from "../../components/blogs/study-abroad";

import "../../styles/blog.css"
import { shortEllipsis} from "../../_helpers/utility-methods";


export const BlogPage = () => {

    const blogId = new URLSearchParams(window.location.search).get('id') || 'blog1';

    const [blog, setBlog] = useState(blogId);

    useEffect(() => {
        setBlog(blogId);
    },[blogId]);

    return (
        <div className="page-body">
            <AppHeader />
            <BodySpacer />
            <PageCaptionImage
                    caption={"Blog"}
                    imageUrl={'/images/blog.jpeg'}
            />
            <div className="blog-page-body">
                {blog === 'blog2' && <Blog2 />}
                {blog === 'blog1' && <Blog1 />}
                <div className="may-like-box">
                    <div className="may-like-unit">
                        <img 
                            src={
                                blog === 'blog2' ?
                                "/images/clock.jpg" :
                                "/images/holding-globe.jpg"
                            } 
                            alt=""
                            className="may-like-pic" 
                            width={200}
                            height={150}
                        />
                        <span className="may-like-cap">
                            {
                                blog === 'blog2' ?
                                "Study Abroad Time Difference: Challenges and Adaptations Across Time and Space":
                                "Study abroad: chasing dreams far away, embracing the wonderful picture of the world"
                            }
                        </span>
                    </div>
                </div>
            </div>
            <AppFooter />
        </div>
    );
}